<template>
    <div>

        <section class="feature-section">
            <div class="container">
                <div class="row ">
                    <div class="col-lg-6 text-left">
                        <h2 class="align-left">AWS Glue + Athena on Steroids</h2>
                        <p>
                          Skippr is your on-ramp to AWS Glue and Athena. With hands-free data ingestion and schema syncing, Skippr discovers your source schemas, and guarantees backwards compatibility as data evolves over time.
                        </p>
                      <p>
                        Imagine your source data always available, always optimised, always complete for working with Parquet in Pandas, SQL in Athena, and trusted schemas to document source models.
                      </p>
                      <p>
                        Enter this brave new world in minutes, it's feels like cheating.
                      </p>
                    </div>
                    <div class="col-lg-5 col-xs-offset-1">
                        <figure>
                          <img src="images/homepage/glue.png" width="100%">
                        </figure>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
    export default {
        name: 'SchemaDrift',
        props: {
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
